module.exports = __webpack_public_path__ + "img/news-hang.e64c957a.jpg";